export const MaxPageInPagination = 100;
